import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import { Grid, Loader } from 'nallian-shared-ui/lib/components';
import FeatureFields from '../fields/FeatureFields';

const CommunityAppFeatures = ({ submitProcessing, appInstallationFetch, readOnly, editMode }) => {
  const nonGlobalAppInstallationFeatures = useMemo(
    () => (appInstallationFetch.value?.appInstallationFeatures || []).filter(f => !f.isGlobal),
    [appInstallationFetch.value]
  );

  if (appInstallationFetch.pending) {
    return <Loader inline active />;
  }

  return (
    <Grid margin="0rem -1rem">
      <Grid.Column mobile={16} tablet={16} computer={16}>
        <FieldArray
          name="communityAppFeatures"
          readOnly={readOnly}
          editMode={editMode}
          component={FeatureFields}
          submitProcessing={submitProcessing}
          features={nonGlobalAppInstallationFeatures}
        />
      </Grid.Column>
    </Grid>
  );
};

CommunityAppFeatures.propTypes = {
  submitProcessing: PropTypes.bool,
  readOnly: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
  appInstallationFetch: PropTypes.object.isRequired,
};

CommunityAppFeatures.defaultProps = { submitProcessing: false };

export default CommunityAppFeatures;
